// src/utils/userPrefs.js
// Single source of truth for persisting all user preferences in localStorage.
// theme and fontSize are also stored via their own utils (for "no flash" boot init).

const PREFS_KEY = 'userPrefs';

const DEFAULTS = {
  theme: 'system',
  fontSize: 'medium',
  language: 'en',
  emailMarketing: false,
  pomodoroMinutes: 25,
  feedPreviewUrl: '',
  effectiveRole: null,
};

export function saveUserPrefs(prefs) {
  try {
    const current = loadUserPrefs();
    localStorage.setItem(PREFS_KEY, JSON.stringify({ ...current, ...prefs }));
  } catch {}
}

export function loadUserPrefs() {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return {
      theme: typeof parsed.theme === 'string' ? parsed.theme : DEFAULTS.theme,
      fontSize: typeof parsed.fontSize === 'string' ? parsed.fontSize : DEFAULTS.fontSize,
      language: typeof parsed.language === 'string' ? parsed.language : DEFAULTS.language,
      emailMarketing: typeof parsed.emailMarketing === 'boolean' ? parsed.emailMarketing : DEFAULTS.emailMarketing,
      pomodoroMinutes: Number(parsed.pomodoroMinutes) > 0 ? Number(parsed.pomodoroMinutes) : DEFAULTS.pomodoroMinutes,
      feedPreviewUrl: typeof parsed.feedPreviewUrl === 'string' ? parsed.feedPreviewUrl : DEFAULTS.feedPreviewUrl,
      effectiveRole: parsed.effectiveRole === 'publisher' || parsed.effectiveRole === 'user'
        ? parsed.effectiveRole
        : DEFAULTS.effectiveRole,
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function getPomodoroMinutes() {
  return loadUserPrefs().pomodoroMinutes;
}
